<template>
  <div class="report-tile">
    <linkTo :href="this.loc_data.url" :newTab="this.loc_data.open_new_tab === true" class="report-tile-content">

      <div class="left-block">
        <div class="icon-wrapper">
          <IconComponent size=24 :url="loc_data.icon_url"/>
        </div>

        <div class="title-block">
          <LabelComponent
                          label_type='h3'
                          :label_text="this.loc(loc_data.name)"/>
          <LabelComponent v-if="loc_data.description"
                          class="title-block__sign"
                          label_type='body/large/regular 14'
                          :label_text="this.loc(loc_data.description)"/>
        </div>
      </div>

      <div class="right-block">
        <IconComponent name="caret-circle-down" type="svg" size="24" class="report-tile-icon"/>
      </div>
    </linkTo>
  </div>
</template>

<script type="text/javascript">

import builder from '../../assets/v1/js/builder';
import LabelComponent from '../unit/Label';
import IconComponent from '../unit/Icon';
import linkTo from '../core/linkTo.vue';

export default builder({
  components: {
    IconComponent,
    LabelComponent,
    linkTo,
  },
  props: ['loc_data'],
});


</script>

<style lang="less">

@import url('../../assets/v1/less/base.less');

@report-tile__background-color: @white;
@report-tile__text__color: @dark;
@report-tile__text__hover__color: @light-green;
@report-tile__icon__background__color: @mint;
@report-tile__icon__color: @green;

@report-tile__next-arrow__icon__color: @green;

.report-tile{
  .flex(column, flex-start, flex-start);
  position: relative;
  //padding: 0 15px 24px;


  .report-tile-content{
    .flex(row,  space-between, center);
    transition: color 0.2s;
    background: @report-tile__background-color;
    text-decoration: none;
    color: @report-tile__text__color;

    padding: 21px 24px;

    width: 100%;
    height: 100%;
    flex-grow: 1;
    border-radius: 10px;
    box-shadow: 0 4px 14px rgba(46, 50, 45, 0.03);
    //margin-top: 10px;


    &:hover{
      color: @report-tile__text__hover__color;

      .left-block .title-block__sign {
        //color: @gray;
      }
    }

    .left-block{
      .flex(row,  flex-start, center);

      .icon-wrapper{
        min-width: 52px;
        max-width: 52px;
        min-height: 52px;
        max-height: 52px;
        background: @report-tile__icon__background__color;
        border-radius: 50%;
        .flex(row,  center, center);
        .set_icon_color(@report-tile__icon__color);

        margin-right: 15px;
      }

      .title-block {
        .flex(column, center, flex-start);
        max-width: 100%;
        margin: 0;

        & > * {
          margin-bottom: 2px;
        }
        & > *:last-child {
          margin-bottom: 0;
        }

        &__sign{
          transition: color 0.2s;

          .set_color(@light-gray)
        }
      }
    }
    .right-block{
      .set_icon_color(@report-tile__next-arrow__icon__color);

      .report-tile-icon {
        transform: rotate(-90deg);
      }
    }
  }


}

@media screen and (max-width: @transition-threshold-1) {
  .report-preview{
    min-width: 100%;
    max-width: 100%;
  }
}
</style>
